import Cookies from 'universal-cookie';
import { LINKS } from '@/Module/Core/Constant';
import type { IPage } from '@/Module/Core/Model/DataModel';
import { LessonDetail } from '@/Module/Lesson/Component';
import { REDIRECT_TOKENS, REPLACE_TOKENS } from '@/Module/Lesson/Constant';
import { getCourseByLessonIdAction, getCourseCategoryByCourseIdAction, getLessonByFriendlyTokenAction, getLessonPlayedPercentageAction, getRelatedLessonListByIdAction, getTeacherByLessonIdAction, updateLessonPooyanPlayTokenAction } from '@/Module/Lesson/Store/Action';
import { selectedLessonSectionSelector } from '@/Module/Lesson/Store/Selector/selectedLessonSectionSelector';
import { lessonSectionSetSelectedLessonSectionIdAction, setRelatedSubscriptionAction, setWatchedPercentage } from '@/Module/Lesson/Store/Slice/LessonSectionSlice';
import { Wrapper } from '@/Module/Store/Component';
import type { IState } from '@/Module/Store/Model';
import { checkCourseHasSubscriptionV2Action } from '@/Module/Subscription/Store/Action';
const LessonListPage: IPage = () => {
  return <LessonDetail data-sentry-element="LessonDetail" data-sentry-component="LessonListPage" data-sentry-source-file="index.tsx" />;
};
export const getServerSideProps = Wrapper.getServerSideProps(store => async ({
  query,
  req,
  res
}) => {
  const slug = String(query?.slug);
  if (REDIRECT_TOKENS.find(token => slug === token)) {
    res.writeHead(301, {
      location: LINKS.GRADE
    });
    res.end();
  }
  if (REPLACE_TOKENS[slug]) {
    res.writeHead(301, {
      location: LINKS.LESSON_SECTION.replace('[id]', REPLACE_TOKENS[slug])
    });
    res.end();
  }
  const cookies = new Cookies(req?.headers?.cookie);
  const accessToken = cookies.get('accessToken');
  if (slug) {
    const data = await store.dispatch(getLessonByFriendlyTokenAction(slug)).unwrap().then(async ({
      id: lessonId,
      courseIds,
      subscriptionPlansStatus
    }) => {
      store.dispatch(lessonSectionSetSelectedLessonSectionIdAction(lessonId));
      store.dispatch(setRelatedSubscriptionAction(Number(subscriptionPlansStatus[0]?.planId) ?? 0));
      const allPromises: Promise<any>[] = [store.dispatch(getTeacherByLessonIdAction(lessonId)), store.dispatch(updateLessonPooyanPlayTokenAction()), store.dispatch(getCourseCategoryByCourseIdAction(courseIds[0])), store.dispatch(getCourseByLessonIdAction(lessonId)), store.dispatch(checkCourseHasSubscriptionV2Action({
        course_id: courseIds[0],
        accessToken
      })), store.dispatch(getRelatedLessonListByIdAction({
        id: lessonId
      }))];
      return Promise.allSettled(allPromises).then(async () => {
        const lessonSection = selectedLessonSectionSelector(store.getState() as IState);
        if (!accessToken || !lessonSection?.duration) return;
        if (lessonSection?.lessonVideoId) {
          await store.dispatch(getLessonPlayedPercentageAction({
            videoId: lessonSection?.lessonVideoId,
            accessToken
          })).unwrap().then(({
            percentage
          }: {
            percentage: number;
          }) => store.dispatch(setWatchedPercentage(percentage))).catch(error => error);
        }
      });
    }).catch(() => {
      return 'SlugNotFound';
    });
    if (data === 'SlugNotFound') {
      return {
        notFound: true
      };
    }
    return {
      props: {}
    };
  }
  return {
    notFound: true
  };
});
export default LessonListPage;